export default function RenderIf({condition = false, children, falsyElement = null}) {
    return condition ? children : falsyElement;
};
